"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VIEW_STATE_BY_PRIVACY_REGIME = exports.TCFConfigInput = exports.TCFBundledDataConfig = exports.TCFConfig = exports.ConsentManagerConfigInput = exports.ConsentManagerConfig = exports.OptionalConsentManagerConfig = exports.RequiredConsentManagerConfig = exports.ExperienceToInitialViewState = exports.PrivacyRegimeToInitialViewState = exports.PrivacyRegimeToInitialViewStateInput = exports.ConsentManagerBreakpoints = exports.ConsentManagerTheme = void 0;
// external
const t = __importStar(require("io-ts"));
// main
const type_utils_1 = require("@transcend-io/type-utils");
// local
const enums_1 = require("./enums");
const core_1 = require("./core");
const iab_1 = require("./iab");
/**
 * Customer theming
 */
exports.ConsentManagerTheme = t.type({
    /** Primary color */
    primaryColor: t.string,
    /** Font color */
    fontColor: t.string,
});
/**
 * Mobile-first responsive breakpoints
 * No media query for mobile, which is the default
 */
exports.ConsentManagerBreakpoints = t.type({
    /** In px, at or above this width is tablet */
    tablet: t.string,
    /** In px, at or above this width is desktop */
    desktop: t.string,
});
/**
 * TODO: https://transcend.height.app/T-19149 - remove
 * @deprecated
 */
exports.PrivacyRegimeToInitialViewStateInput = t.partial((0, type_utils_1.applyEnum)(enums_1.PrivacyRegimeEnum, () => (0, type_utils_1.valuesOf)(enums_1.InitialTranscendViewState)));
/**
 * TODO: https://transcend.height.app/T-19149 - remove
 * @deprecated
 */
exports.PrivacyRegimeToInitialViewState = t.record((0, type_utils_1.valuesOf)(enums_1.PrivacyRegimeEnum), (0, type_utils_1.valuesOf)(enums_1.InitialTranscendViewState));
exports.ExperienceToInitialViewState = t.record(t.string, (0, type_utils_1.valuesOf)(enums_1.InitialViewState));
exports.RequiredConsentManagerConfig = t.type({
    /** Customer theming */
    theme: exports.ConsentManagerTheme,
    /** A set of responsive breakpoints */
    breakpoints: exports.ConsentManagerBreakpoints,
    /** The privacy policy URL to redirect to */
    privacyPolicy: t.string,
    /** The secondary policy URL to redirect to */
    secondaryPolicy: t.string,
    /** Custom CSS stylesheet */
    css: t.string,
    /** Path to localizations directory */
    messages: t.string,
    /** What state the consent manager should launch in */
    initialViewStateByPrivacyRegime: exports.ExperienceToInitialViewState,
    /** What state the consent manager should go to when dismissed */
    dismissedViewState: (0, type_utils_1.valuesOf)(enums_1.DismissedViewState),
});
exports.OptionalConsentManagerConfig = t.partial({
    /** The set of enabled languages - CSV of ConsentManagerLanguageKey */
    languages: t.string,
    /** The override value for the consent banner z-index */
    uiZIndex: t.string,
    /**
     * The override value for the consent banner shadow root state
     *
     * Potential values: 'closed' (default) and 'open'
     */
    uiShadowRoot: t.string,
    /**
     * The override value for whether to focus on the first descendant of the root arg w/data-initialFocus attribute
     * Potential values: `'on'` (default) or `'off'`
     *
     */
    autofocus: core_1.BooleanString,
});
/** Consent manager UI configuration */
exports.ConsentManagerConfig = t.intersection([
    exports.RequiredConsentManagerConfig,
    exports.OptionalConsentManagerConfig,
]);
/** Input for Consent manager UI configuration */
exports.ConsentManagerConfigInput = t.partial({
    ...exports.OptionalConsentManagerConfig.props,
    ...exports.RequiredConsentManagerConfig.props,
});
exports.TCFConfig = t.type({
    /** Path to vendor-list.json */
    vendorList: t.string,
    /** Custom CSS stylesheet */
    css: t.string,
    /** Path to localizations directory */
    messages: t.string,
});
/** Configuration that are passed directly to the TCF module, not via airgap.j */
exports.TCFBundledDataConfig = t.partial({
    /** Mapping of TCF Purpose ID to airgap tracking types */
    purposeMap: t.array(t.tuple([t.number, t.array(t.string)])),
    /** These TCF purposes cannot be processed on the basis of legitimate interests */
    restrictLegitimateInterestPurposes: t.array(t.number),
    /** Vendors that Transcend Consent regulates because they haven't registered with IAB TCF */
    nonTcfVendors: t.array(iab_1.NonTcfVendor),
    /** Comma separated list of languages to support in the UI */
    languages: t.string,
    /** Default locale to use for the UI internationalization  */
    locale: t.string,
    /**
     * Whether or not to enable integration between Google Consent Mode and TCF.
     * More docs here https://developers.google.com/tag-platform/security/guides/implement-TCF-strings#cmp-api
     */
    enableAdvertiserConsentMode: t.boolean,
});
/** Input for Consent manager UI configuration */
exports.TCFConfigInput = t.partial(exports.TCFConfig.props);
exports.DEFAULT_VIEW_STATE_BY_PRIVACY_REGIME = {
    // EU
    GDPR: enums_1.InitialViewState.QuickOptions,
    // Brazil
    LGPD: enums_1.InitialViewState.QuickOptions,
    // Switzerland
    nFADP: enums_1.InitialViewState.QuickOptions,
    // US: California
    CPRA: enums_1.InitialViewState.Hidden,
    // US: Virginia
    CDPA: enums_1.InitialViewState.Hidden,
    // US: Colorado
    CPA: enums_1.InitialViewState.Hidden,
    // US: Nevada
    NEVADA_SB220: enums_1.InitialViewState.Hidden,
    // Other
    Unknown: enums_1.InitialViewState.Hidden,
    // US Do Not Sell/Share
    US_DNSS: enums_1.InitialViewState.Hidden,
};
//# sourceMappingURL=ui.js.map